<template>
  <div class="section_header" :class="textAlign">
    <h4 :class="textColor">{{ subTitle }}</h4>
	<hr class="line" :class="textColor">
	<h1 :class="textColor">{{topText}}
	   <span v-if="middleText"><br/>{{middleText }}</span>
	   <span v-if="bottomText"><br/>{{bottomText }}</span>
   </h1>
	<hr class="line" :class="textColor">
  </div>
</template>
<!-- topBar
bottomBar
blue -->
<script>
export default {
  name: "SectionHeader",
  props: ["textColor", "subTitle", "topText", "middleText", "bottomText", "textAlign"],
};
</script>

<style lang="scss" scoped>
.section_header {
	&.left{
		display:flex;
		flex-direction:column;
		// align-items: flex-end;
		text-align:left;
	}
	&.center{
		display:flex;
		flex-direction:column;
		justify-content: center;
		align-items: center;
		text-align:center;
		hr{
			&.white{
				@include media-breakpoint-down(sm) {
					width: 315px;
				}

			}
		}
	}
	&.right{
		display:flex;
		flex-direction:column;
		// justify-content: center;
		align-items: flex-end;
		text-align:right;
	}
	hr{
		height: 6px;
		margin: 10px 0px;
		opacity:1;
		width: 370px;
		@include media-breakpoint-down(sm) {
			 margin: 5px auto;
			 width: 330px;
		}
		@media only screen and (min-width: 578px) and (max-width: 900px)  {
			margin: 5px auto;
			width: 330px;
		}
		&.orange{
			color:#F16924;
			background-color:#F16924;

		}
		&.white{
			color:#FFFFFF;
			background-color:#FFFFFF;

		}
		&.blue{
			color: theme-var($--ch-theme-primary);
			background-color:theme-var($--ch-theme-primary);

		}
	}
	h4{
		font-family: "GeogrotesqueSharp-ExpBd";
		font-size: 12px;
		letter-spacing: 0;
		line-height: 16px;
		font-weight: 700;
		text-transform:uppercase;
		&.orange{
			color: theme-var($--ch-theme-secondary);
		}
		&.white{
			color: theme-var($--ch-theme-on-primary);
		}
		&.blue{
			color: theme-var($--ch-theme-primary);
		}
		@include media-breakpoint-down(sm) {
			font-size: 12px;
			text-align: center;
		}
		@media only screen and (min-width: 578px) and (max-width: 900px)  {

			text-align: center;
		}
	}
	h1{
		font-family: "GeogrotesqueSharp-ExpBd";
		font-size: 34px;
		letter-spacing: 0;
		line-height: 110%;
		font-weight: 700;
		margin: 20px 0px;
		text-transform:uppercase;
		&.orange{
			color: theme-var($--ch-theme-secondary);
		}
		&.white{
			color: theme-var($--ch-theme-on-primary);
		}
		&.blue{
			color: theme-var($--ch-theme-primary);
		}
		@include media-breakpoint-down(sm) {
			font-size: 22px;
			padding: 0px 5px ;
			// margin: 20px 0px;
			text-align: center;
		}
		@media only screen and (min-width: 578px) and (max-width: 900px)  {

			text-align: center;
		}
	}

}
</style>
